import * as React from 'react';

const DoubleArrowSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fillRule="evenodd">
            <path d="M15 4l-.614.614L18.736 9H4v1h16V9l-5-5zM9 20l.614-.614L5.264 15H20v-1H4v1l5 5z" />
        </g>
    </svg>
);

DoubleArrowSvg.displayName = 'DoubleArrowSvg';
export default DoubleArrowSvg;
